module.exports = __webpack_public_path__ + "static/media/pilic.3399bde9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pilic.jpg
// module id = 552
// module chunks = 0